import React from "react";
import Label from "../ui/label/Label";
import DropdownSelect from "../ui/dropdown/DropDrown";
import PropTypes from "prop-types";

const ClientDropdownFilter = (props) => {
  const handleChange = (data) => {
    if (props.onChange) {
      props.onChange(data, props.dropdownType);
    }
  };

  return (
    <div className="input-label-part">
      <Label labelName={props.label} />
      <DropdownSelect
        value={props.selectedValue}
        options={props.listOptions}
        placeholder={props.placeholder}
        onChange={handleChange}
        isDisabled={props.isDisable}
      />
    </div>
  );
};

ClientDropdownFilter.propTypes = {
  label: PropTypes.string.isRequired, // Label text for the dropdown
  selectedValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]), // Selected value in the dropdown
  listOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ).isRequired, // Options for the dropdown
  placeholder: PropTypes.string, // Placeholder for the dropdown
  onChange: PropTypes.func, // Callback function when value changes
  dropdownType: PropTypes.string, // Type of dropdown for differentiation
  isDisable: PropTypes.bool, // Whether the dropdown is disabled
};

export default ClientDropdownFilter;
